import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAuthVerify_email_token = z.any()
export type TagsPostAuthVerify_email_token = z.infer<typeof tagsPostAuthVerify_email_token>

export const paramsPostAuthVerify_email_token = z.object({ "token": z.string() })
export type ParamsPostAuthVerify_email_token = z.infer<typeof paramsPostAuthVerify_email_token>

export const responsePostAuthVerify_email_token = z.any()
export type ResponsePostAuthVerify_email_token = z.infer<typeof responsePostAuthVerify_email_token>

interface IPostAuthVerify_email_token extends BaseMethodType {
  tags: TagsPostAuthVerify_email_token,
  params: ParamsPostAuthVerify_email_token,
  response: ResponsePostAuthVerify_email_token
}
export const URL = '/auth/verify-email/:token'
export const validation = {
  post: {
    tags: tagsPostAuthVerify_email_token,
    params: paramsPostAuthVerify_email_token,
    response: responsePostAuthVerify_email_token
  }
}
export interface AuthVerify_email_token extends BaseRouteType {
  post: IPostAuthVerify_email_token
}